import type { AuditResult, RecordAuditReport } from "../types";

// Parse the JSON RecordAuditReport stored on a record (records.extraction_audit).
export function parseAudit(
  raw: string | null | undefined,
): RecordAuditReport | null {
  if (!raw) return null;
  try {
    const r = JSON.parse(raw) as RecordAuditReport;
    return Array.isArray(r.checks) ? r : null;
  } catch {
    return null;
  }
}

// True when a record has a stored audit with at least one flagged check.
export function isAuditFlagged(raw: string | null | undefined): boolean {
  return parseAudit(raw)?.flagged ?? false;
}

const CHECK_LABELS: Record<AuditResult["check"], string> = {
  date: "Date",
  sender: "Sender / recipient",
  subject: "Subject",
  amounts: "Amounts",
  significance: "Significance",
  ocr: "OCR text",
  transcription: "Transcription",
  attachments: "Attachments",
  thread: "Thread split",
};

export function checkLabel(check: AuditResult["check"]): string {
  return CHECK_LABELS[check] ?? check;
}

// Human row for the detail view: "✓ Date verified" / "⚠ Date not found …".
export function checkSummary(c: AuditResult): string {
  const label = checkLabel(c.check);
  if (c.status === "verified") return `${label} verified`;
  if (c.status === "no_source_text") return `${label} — no source text to verify`;
  return c.issues[0] ?? `${label} flagged`;
}
